import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LOCALES } from '../constants/locales';
import { useCountry } from '../context/CountryContext';

const languages = LOCALES;

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const { setCountry } = useCountry();
  const [isOpen, setIsOpen] = useState(false);
  const buttonRef = useRef(null);

  const changeLanguage = (code) => {
    const locale = LOCALES.find((l) => l.code === code);
    i18n.changeLanguage(code);
    if (locale) {
      setCountry(locale.country);
    }
    setIsOpen(false);
  };

  return (
    <div className='language'>
       <div className="language-selector" ref={buttonRef}>
      <button className="lang-button" onClick={() => setIsOpen(!isOpen)}>
        🌐
      </button>

      {isOpen && (
        <div className="lang-modal">
          <ul className="lang-list">
            {languages.map((lang) => (
              <li key={lang.code}>
                <button onClick={() => changeLanguage(lang.code)}>
                  <img
                    src={`https://flagcdn.com/24x18/${lang.countryCode}.png`}
                    alt={lang.label}
                    className="flag"
                  />{' '}
                  {lang.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
    </div>
  );
}
